module.exports = __webpack_public_path__ + "assets/img/timeLine_img8.ae55b368.png";